import React from 'react'

const CloverLayout = ({ children }) => {
  return <div>{children}</div>
}

export default CloverLayout
